export default __webpack_public_path__ + "static/media/p-4.64fa2ed6.png";